const commonResources = {
    zh: {
        translation: {
            // basic
            'common-back': '返回',
        }
    }
}

export default commonResources